import React, { memo } from 'react'; // 1. Import memo
import Image from '../../Image/image-component';
import useScrollOrNavigate from '../../../Hooks/useScrollOrNavigate';

const GridCard = ({ item, className = '', imgClassName = '', textCenter = false, layout = 'stacked', onClick }) => {
    if (!item) return null;
    const isSideBySide = layout === 'side-by-side';

    return (
        <section
            onClick={onClick}
            style={{ backgroundColor: item.bgColor }}
            className={`relative group overflow-hidden rounded-[28px] cursor-pointer ${isSideBySide ? 'p-0' : 'p-6 md:p-10'} flex ${isSideBySide ? 'flex-row' : 'flex-col justify-between'} transition-transform duration-300 hover:scale-[1.01] ${item.bgColor || 'bg-gray-100'} ${item.textColor || 'text-gray-900'} ${className}`}
        >
            <div className={`relative z-10 ${isSideBySide ? 'w-1/2 p-6 md:p-10 flex flex-col justify-center' : 'w-full'} ${textCenter ? 'flex flex-col items-center text-center' : ''}`}>
                {item.icon && (
                    <div className="mb-6 w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-sm">
                        <img src={item.icon} alt="" className="w-10 h-10" />
                    </div>
                )}
                <h2 className="text-3xl md:text-4xl font-medium mb-4 leading-tight">{item.title}</h2>
                {item.description && (
                    <p className={`text-lg md:text-xl opacity-90 ${textCenter ? '' : 'max-w-md'}`}>{item.description}</p>
                )}
            </div>
            <div className={`relative z-0 transition-all duration-500 ${isSideBySide ? 'w-1/2 h-full' : 'w-1/4 mt-auto'}`}>
                {item.image && (
                    <Image
                        src={item.image}
                        alt={item.title}
                        useSekeleton={false}
                        quality={100}
                        className={`w-full h-full ${imgClassName} ${isSideBySide ? 'object-cover' : 'object-contain'}`}
                        wrapperClassName="w-full h-full"
                    />
                )}
            </div>
        </section>
    );
};

// 2. Wrap the component in memo()
const ImageGrid = memo(({ items = [] }) => {
    const handleScrollOrNavigate = useScrollOrNavigate();

    console.log('ImageGrid items:', items);
    if (items.length === 0) return null;

    const [item1, item2, item3, item4] = items;

    const handleCardClick = (link) => (e) => {
        if (!link) return;
        const targetId = link === '/contact' ? 'contact-form' : null;
        handleScrollOrNavigate(e, targetId, link);
    };

    return (
        <div className="flex justify-center w-full px-4 py-8">
            <div className="max-w-7xl w-full flex flex-col gap-8">
                {/* Top Row */}
                <div className="grid grid-cols-1 md:grid-cols-[3fr_2fr] gap-8 min-h-[400px]">
                    <GridCard
                        item={item1}
                        layout="side-by-side"
                        className="min-h-[350px]"
                        imgClassName="object-right-top"
                        onClick={handleCardClick(item1?.link)}
                    />
                    <GridCard
                        item={item2}
                        textCenter={true}
                        className="min-h-[300px]"
                        imgClassName="transition-transform duration-500"
                        onClick={handleCardClick(item2?.link)}
                    />
                </div>

                {/* Bottom Row */}
                <div className="grid grid-cols-1 md:grid-cols-[1fr_2fr] gap-8 min-h-[500px]">
                    <GridCard
                        item={item3}
                        textCenter={true}
                        className="min-h-[300px] items-center justify-center"
                        onClick={handleCardClick(item3?.link)}
                    />
                    <GridCard
                        item={item4}
                        layout="side-by-side"
                        className="min-h-[350px]"
                        imgClassName="object-left-top"
                        onClick={handleCardClick(item4?.link)}
                    />
                </div>
            </div>
        </div>
    );
});

export default ImageGrid;